/** Permissions that grant access to review / approve leave requests (sidebar + routes). */
export const LEAVE_REVIEW_MENU_PERMISSIONS = [
  "leave.read",
  "leave.approve",
  "leave.reject",
];

/** Permissions that grant approve/reject actions on leave rows. */
export const LEAVE_ACTION_PERMISSIONS = ["leave.approve", "leave.reject"];
